import React from "react";
import axios from "axios";
import MainPageDialog from "../mainPageDialog";
import "./tos_styles.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { Loader } from "../Loader";
import { useNavigate } from "react-router-dom";
import {
  setLocalStorage,
  isCaregiver,
  isPatient,
  getLoggedinUser,
} from "../../userStore";
import { getBaseUrl } from "../../utils/common_lib";

function Accept({
  showAcceptPopUp,
  setShowAcceptPopUp,
  setShowDeclinePopUp,
  termsAndConditions,
  authToken,
  loadingTos,
  userData,
  setShowTosModal,
  agreementType,
}) {
  const [showUserAgreement, setShowUserAgreement] = React.useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = React.useState(false);
  const [agree, setAgree] = React.useState(false);
  const navigate = useNavigate();

  const handleAcceptTos = () => {
    axios
      .post(
        `${getBaseUrl()}/users/accept_terms_and_conditions.json?token=${authToken}`,
        {
          status: 1,
        }
      )
      .then((response) => {
        // console.log("response", response);
        // toast.success("Terms and conditions accepted successfully");
        setLocalStorage("isLoggedIn", true);
        setLocalStorage("session", userData);
        navigate("/dashboard");
        ///redirect to dashboard
        const user = getLoggedinUser();
        if (user?.firstlogin === 1 || user?.pincode === "") {
          navigate("/create-pin");
        } else {
          if (isPatient()) {
            navigate("/dashboard");
          } else if (isCaregiver()) {
            navigate("/patients");
          } else {
            navigate("/dashboard");
          }

          toast.success("Login successful");
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log("error", error);
        // toast.error("Error accepting terms and conditions");
      });
  };

  const footerList = [
    agreementType !== "agreed" && {
      title: "Disagree",
      type: "cancel",
      action: () => {
        setShowAcceptPopUp(false);
        setShowDeclinePopUp(true);
      },
    },
    agreementType !== "agreed" && {
      title: "Agree",
      type: "save",
      disabled: !agree,
      action: () => {
        if (authToken) {
          handleAcceptTos();
          setShowAcceptPopUp(false);
          setShowTosModal(false);
        } else {
          // toast.error("Token Expired. Please login again.");
        }
      },
    },
    agreementType === "agreed" && {
      title: "Close",
      type: "cancel",
      action: () => {
        setShowAcceptPopUp(false);
        setShowTosModal(false);
        setShowDeclinePopUp(false);
      },
    },
  ];

  return (
    <div>
      <MainPageDialog
        title="Terms & conditions"
        modalSize="large"
        maxHeight={true}
        footerList={footerList}
        onCancelHandler={() => {
          setShowAcceptPopUp(false);
          setShowDeclinePopUp(true);
          setShowTosModal(false);
        }}
      >
        {loadingTos ? (
          <Loader />
        ) : (
          <div className="flex flex-col gap-4">
            {/* Term and conditions **/}
            <div id="terms_and_condtions">
              <div
                className="flex gap-2 items-center panel-title"
                role="button"
                tabIndex={0}
                onClick={() => setShowUserAgreement(!showUserAgreement)}
                onKeyDown={() => setShowUserAgreement(!showUserAgreement)}
              >
                {showUserAgreement ? <FaMinus /> : <FaPlus />}
                End User License and Terms of Use Agreement
              </div>
              {showUserAgreement && (
                <div
                  className="mt-2"
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.[1]?.text,
                  }}
                />
              )}
            </div>
            {/* Privacy Policy **/}
            <div id="privacy_policy">
              <div
                className="flex gap-2 items-center panel-title"
                role="button"
                tabIndex={0}
                onClick={() => setShowPrivacyPolicy(!showPrivacyPolicy)}
                onKeyDown={() => setShowPrivacyPolicy(!showPrivacyPolicy)}
              >
                {showPrivacyPolicy ? <FaMinus /> : <FaPlus />}
                Privacy Policy
              </div>
              {showPrivacyPolicy && (
                <div
                  className="mt-2"
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.[2]?.text,
                  }}
                />
              )}
            </div>
            {/* Acknowledgement **/}
            {agreementType !== "agreed" && (
              <div id="acknowledgement">
                <div className="flex gap-2 items-center">
                  <input
                    type="checkbox"
                    onChange={(e) => setAgree(e?.target?.checked)}
                  />
                  <p className="text-[18px]">Acknowledgement</p>
                </div>
                <div
                  className="mt-2"
                  dangerouslySetInnerHTML={{
                    __html: termsAndConditions?.[3]?.text,
                  }}
                />
              </div>
            )}
          </div>
        )}
      </MainPageDialog>
    </div>
  );
}

export default Accept;
